import baseRoute from '../baseRoute';

export default `${baseRoute}/workOrderReport` as const;
